import { Button, Modal } from 'react-daisyui';
import { useTeamContext } from '../../Team.context';
import { CheckBadgeIcon, LinkIcon, XMarkIcon } from '@heroicons/react/16/solid';
import { useEffect, useState } from 'react';

export default function UserCreatedConfirmation() {
  const { showUserCreatedModal, toggleUserCreatedModal, addUserFormik } =
    useTeamContext();

  const [copiedEmail, setCopiedEmail] = useState<boolean>(false);
  const [copiedPassword, setCopiedPassword] = useState<boolean>(false);
  const [copiedLink, setCopiedLink] = useState<boolean>(false);

  // Reset form when modal closes
  useEffect(() => {
    if (!showUserCreatedModal) {
      addUserFormik?.resetForm();
    }
  }, [showUserCreatedModal, addUserFormik]);

  return (
    <Modal
      open={showUserCreatedModal}
      className="UserCreatedModal"
      backdrop={true}
      responsive={true}
    >
      <Modal.Header className="UserCreatedModal__Header">
        <h1>Usuario agregado 🎉</h1>
        <Button
          color="ghost"
          size="sm"
          shape="square"
          onClick={() => {
            toggleUserCreatedModal(false);
            addUserFormik?.resetForm();
          }}
        >
          <XMarkIcon className="UserCreatedModal__CloseIcon" />
        </Button>
      </Modal.Header>
      <Modal.Body className="UserCreatedModal__Body">
        <div className="UserCreatedModal__SuccessIconContainer">
          <CheckBadgeIcon className="UserCreatedModal__SuccessIcon" />
        </div>
        <p className="UserCreatedModal__SuccessMessage">
          {`Se ha creado el usuario de manera correcta, la cuenta es ${addUserFormik?.values.email}`}
        </p>
        <p className="UserCreatedModal__Instruction">
          Para que tu usuario acceda es importante compartir:
        </p>
        <div className="UserCreatedModal__InstructionRow">
          <p className="UserCreatedModal__InstructionText">
            1️⃣ El correo que agregaste
          </p>
          <Button
            size="sm"
            color="ghost"
            variant="outline"
            onClick={() => {
              navigator.clipboard.writeText(addUserFormik?.values.email ?? '');
              setCopiedEmail(true);
            }}
            className="UserCreatedModal__CopyButton"
          >
            <p>{copiedEmail ? 'Copiado' : 'Copiar'}</p>
            <LinkIcon className="UserCreatedModal__CopyButtonIcon" />
          </Button>
        </div>
        <div className="UserCreatedModal__InstructionRow">
          <p className="UserCreatedModal__InstructionText">
            2️⃣ La contraseña que creaste
          </p>
          <Button
            size="sm"
            color="ghost"
            variant="outline"
            onClick={() => {
              setCopiedPassword(true);
            }}
            className="UserCreatedModal__CopyButton"
          >
            <p>{copiedPassword ? 'Copiado' : 'Copiar'}</p>
            <LinkIcon className="UserCreatedModal__CopyButtonIcon" />
          </Button>
        </div>
        <div className="UserCreatedModal__InstructionRow">
          <p className="UserCreatedModal__InstructionText">
            3️⃣ El link de acceso
          </p>
          <Button
            size="sm"
            color="ghost"
            variant="outline"
            onClick={() => {
              navigator.clipboard.writeText('https://leadsales.services/login');
              setCopiedLink(true);
            }}
            className="UserCreatedModal__CopyButton"
          >
            <p>{copiedLink ? 'Copiado' : 'Copiar'}</p>
            <LinkIcon className="UserCreatedModal__CopyButtonIcon" />
          </Button>
        </div>
      </Modal.Body>
      <Modal.Actions>
        <Button
          color="primary"
          fullWidth
          onClick={() => {
            toggleUserCreatedModal(false);
            addUserFormik?.resetForm();
          }}
        >
          Entendido
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
